import { render, staticRenderFns } from "./referralLeadsCount.vue?vue&type=template&id=27499511"
import script from "./referralLeadsCount.vue?vue&type=script&lang=js"
export * from "./referralLeadsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports